import React, { useRef, useState } from 'react';
import ToastInner from './ToastInner';
import { Toast, ToastContainer } from './toastStyles';
import { IonModal } from '@ionic/react';

type ToastHandlerProps = {
	isToastOpen: boolean;
};
const ToastHandler: React.FC<ToastHandlerProps> = ({ isToastOpen }) => {
	const [sheetOpen, setSheetOpen] = useState(false);
	const sheetModal = useRef(null);
	// TODO: Animate in and out based on current location and nearest point
	return (
		<>
			<ToastContainer className={isToastOpen ? '' : 'hidden'}>
				<Toast
					onClick={() => {
						setSheetOpen(true);
					}}>
					<ToastInner />
				</Toast>
			</ToastContainer>
			<IonModal
				keepContentsMounted={true}
				onDidDismiss={() => setSheetOpen(false)}
				ref={sheetModal}
				isOpen={sheetOpen}
				initialBreakpoint={0.5}
				breakpoints={[0, 0.5, 0.95]}>
				{/* TODO: modal  */}
				MoreInfo Modal Inner to go here!
			</IonModal>
		</>
	);
};

export default ToastHandler;
